module.exports = __webpack_public_path__ + "img/fit_air.db8b0f0b.webp";